import styled from 'styled-components';

interface TranslationStatusWrapperProps {
  status: 'pending' | 'success' | 'error';
}

const getTextColor = (status: TranslationStatusWrapperProps['status']) :string => {
  switch (status) {
    case 'pending':
      return '#FF9800';
    case 'error':
      return '#F44336';
    default:
      return '#000';
  }
};

export const TranslationStatusWrapper = styled.div<TranslationStatusWrapperProps>`
    padding: 2px 10px!important;
    display: inline-flex;
    height: 25px;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-size: 12px;
    color: ${({ status }) => getTextColor(status)};
    font-weight: 400;
    position: relative;
`;
